import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import WebHeader from "../components/WebHeader";
import WebFooter from "../components/WebFooter";
import PostContent from "../components/PostContent";
import PopUp from "../components/PopUp";


export default function PostSharing() {
    const { search } = useLocation();
    let pid = queryString.parse(search).pid;

    const [popUpState, setPopUpState] = useState({
        isOpen: false,
        popUpType: "",
    });

    return (
        <div className="post-setting">
            {/* Pop Up */}
            <div className={popUpState.isOpen ? "popup-fixed-box" : "popup-notshow"}>
                <PopUp pid={pid} popUpState={popUpState} setPopUpState={setPopUpState} />
            </div>

            {/* Post */}
            <div className="post">
                <div className="web-flex-box">
                    <WebHeader popUpState={popUpState} setPopUpState={setPopUpState} />
                </div>

                <div className="web-row">
                    <div className="post-body">
                        <PostContent pid={pid} popUpState={popUpState} setPopUpState={setPopUpState} />
                    </div>
                </div>

                <div className="web-row web-footer-outer-box">
                    <footer className="web-footer">
                        <WebFooter />
                    </footer>
                </div>
            </div>
        </div>
    );
}
